import React from 'react';
//import {RouteState, ROUTE_UPDATE_EVENT, ENABLE_EVENT} from '../../state/routing/index';

import { connect } from 'react-redux';
import IconButtons from '../components/buttons/iconButtons';
import { toggleDraw, toggleDrawButtonsVisiblity, toggleActive, clearDraw } from '../draw/actions';
import { displayText } from '../lang/index';
import { map } from '../map/map';
import { isMax } from '../draw/reducer';
import { easeOut } from 'ol/easing.js';
//import {mapState, PADDING_SPACE_EVENT} from '../../state/map';

const setView = (coords, zoom) => {
  let view = map.getView();
  
  view.animate({
    center: coords,
    zoom: zoom,
    duration: 1000
  });
  
};

var zoomByDelta = function(delta) {

  var view = map.getView();
  var zoom = view.getZoom();
  
  view.animate({
    zoom: zoom + delta,
    duration: 200
  });
};

const mapStateToPropsRes = (state) => {

  var drawEnabled = !isMax(state.draw);

  if(drawEnabled) {
    var activeBttID = state.draw.drawType;
  } else {
    var activeBttID = '';
  }

  const drawButtonsVisible = state.draw.drawButtonsVisible;

  /*
  var gpsIcon = '';
  if(state.gps.enabled) {
    gpsIcon = 'GpsOff';
  } else {
    gpsIcon = 'GpsFixed';
  }
  */
  return {
    activeBttID: activeBttID,
  	buttons: [
    //  {id: 'GpsFixed', title:displayText('GPS_BUTTON'), enabled: state.gps.enabled, active: true, visible: true},
    //  {id: 'break'},
      //{id: 'zoom_group', children: [
        {id: 'plus', title:displayText('ZOOM_IN'), enabled: false, active: true, visible: true},
        {id: 'minus', title:displayText('ZOOM_OUT'), enabled: false, active: true, visible: true},
      //]},
      {id: 'break'},
      {id: 'Point', title:displayText('DRAW_POINT'), enabled: false, active: drawEnabled, visible: drawButtonsVisible},
      {id: 'RulerLine', title:displayText('DRAW_LINE'), enabled: false, active: drawEnabled, visible: drawButtonsVisible},
   //   {id: 'RulerPolygon', title:displayText('DRAW_SHAPE'), enabled: false, active: drawEnabled, visible: drawButtonsVisible},
      //{id: 'Circle', enabled: false, active: drawEnabled},
      //{id: 'RulerLine', enabled: false, active: drawEnabled, visible: drawButtonsVisible},
      {id: 'clear', title:displayText('CLEAR_DRAWINGS'), enabled: false, active: true, visible: drawButtonsVisible},
      {id: 'DrawToggle', title:displayText('DRAW_TOGGLE'), enabled: drawButtonsVisible, active: true, visible: true},
    //  {id: 'break'},
      //{id: 'view_group', children: [
    //    {id: 'LVA', title:displayText('LVA_VIEW'), enabled: false, active: true, visible: true},
    //    {id: 'RIX', title:displayText('RIX_VIEW'), enabled: false, active: true, visible: true}
      //]},
      /*,
      {id: gpsIcon, enabled: false, active: true}*/
    ]
  };
};

const mapDispatchToPropsRes = (dispatch) => {

  return {
    onClick: data => {

      switch(data.id) {
          case 'DrawToggle':
            dispatch(toggleDrawButtonsVisiblity());
            break;
          case 'Point':
          case 'LineString':
          case 'Polygon':
          case 'Circle':
          case 'RulerPolygon':
          case 'RulerLine':
              dispatch(toggleDraw({drawType: data.id}));
              break;
          case 'RIX':
              setView([2684130.14,7749200.71], 14);
              break;
          case 'LVA':
              setView([2706129.54,7751524.89], 8);
              break;
          case 'clear':
              dispatch(clearDraw({updateSource: 'UI'}));
             
              break;
          case 'plus':
              
              zoomByDelta(1);
          //  map.getView().setZoom(map.getView().getZoom()+1);

            break;
          case 'minus':
              
              zoomByDelta(-1);

              break;
          case "GpsFixed":
            dispatch(gpsToggle(false));
            break;
          case "GpsOff":
            dispatch(gpsToggle(true));
            break;
          default:
            console.log('wrong btt');
      }
    }
  };
};

const MapButtons = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(IconButtons);


export default MapButtons;